import {Component, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {MdDialog, MdDialogConfig, MdDialogRef, MdSnackBar} from '@angular/material';
import {AgrisInsertInsumCotizDialogComponent} from './agris-insert-insum-cotiz-dialog';
import {AgrisEditPriceInsCotizDialogComponent} from './agris-edit-price-ins-cotiz-dialog';
import {AgrisCotizDetalleGuardarDialogComponent, GuardarCotizOptions} from './agris-cotiz-detalle-guardar-dialog';
import {AgrisCotizDetallePnjdeDialogComponent} from './agris-cotiz-detalle-pnjde-dialog';
import {AgrisCotizDetalleRenovarDialogComponent} from './agris-cotiz-detalle-renovar-dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {
  ActividadAgrisViewModel,
  AgrisEstadosIds,
  AgrisService,
  CuentasService,
  editedInsumosKey,
  HttpClient,
  ModalidadFacturacionIds,
  PERM_ACCIONES_ID,
  PermisosService,
  SpinnerService
} from '../../../services';
import {CotizacionAgrisViewModel, InsumoCotizacionViewModel, InsumoViewModel, OficinaComercialViewModel} from '../common/AgrisViewModels';
import {NumberEditDialogComponent} from '../../common';
import {PATH_AGRIS_COTIZACION_DETALLE, PATH_AGRIS_NUEVA_COTIZACION} from '../../../navigation/navigation.module';
import {ClientContactViewModel, ClienteViewModel} from '../../../utils/ViewModels';
import * as moment from 'moment';
import {AgrisCorizPerderDialogComponent} from './agris-coriz-perder-dialog';
import {AgrisCantidadSelectorComponent, AgrisConfirmDialogComponent} from '../common';

@Component({
  selector: 'app-agris-cotizacion-detalle-page',
  templateUrl: './agris-cotizacion-detalle-page.component.html',
  styleUrls: ['./agris-cotizacion-detalle-page.component.scss', '../common/agris-common-styles.scss']
})
export class AgrisCotizacionDetallePageComponent implements OnInit, OnDestroy {

  sub: Subscription[] = [];

  insumos: InsumoDetalleCotiz[] = [];

  cotizacion: CotizacionAgrisViewModel = null;
  loading = false;

  mails: ClientContactViewModel[] = [];

  // usaremos esta variable mientras estamos en Enviada activa para permitir ediciones sin importar el estado
  forceEdit = false;

  // usamos esta variable para identificar si es admin o puede editar segun zona
  canView = false;

  oficinasVisibles: OficinaComercialViewModel[] = [];

  actividad: ActividadAgrisViewModel[] = [];
  actividadExpand = false;
  actividadLoading = false;
  actividadErrMsg = 'Ésta cotización no posee actividades';

  @ViewChildren('cantidadSelectorComponent') cantidadSelectors: QueryList<AgrisCantidadSelectorComponent>;

  constructor(
    private dialog: MdDialog,
    private route: ActivatedRoute,
    private agrisService: AgrisService,
    private httpService: HttpClient,
    private permServ: PermisosService,
    private snackBar: MdSnackBar,
    private router: Router,
    private cuentasService: CuentasService,
    private spinnerService: SpinnerService,
  ) {
    permServ.verificarAccesoDeURL();
    this.canView = permServ.permisoAutorizado(PERM_ACCIONES_ID.A_Admin_Agris);
    agrisService.oficinas$.subscribe(x => {
      this.oficinasVisibles = x;
      this.checkViewOficinas();
    });
  }

  ngOnInit() {
    this.route.params.subscribe(() => {
      const id = this.route.snapshot.params['id'];
      this.loadData(id);
    });

    // obtenemos el estado force edit desde el servicio pero lo reseteamos para evitar que se mantenga en el tiempo al cambiar de cotizacion
    this.forceEdit = this.agrisService.forceEdit;
    this.agrisService.forceEdit = false;

  }

  loadData(id) {
    this.loading = true;
    this.actividad = [];
    this.httpService.getGeneric<CotizacionAgrisViewModel>(`/api/agris/get-cotizacion/${id}`).subscribe(x => {
      if (x && x.NumeroCotizacion) {
        this.cotizacion = x;
        this.cotizacion.EstadosCotizacion.reverse();
        this.insumos = this.cotizacion.InsumosCotizacion ? this.cotizacion.InsumosCotizacion.map(x => ({...x, opened: false, precioFinal: x.PrecioLista}) as InsumoDetalleCotiz) : []
        // verificamos si se intenta añadir un insumo desde el dralle de insumos
        if (this.agrisService.insumoToAddToCotiz !== null) {
          // verificamos que no se encuentre ya en la lista
          if (this.insumos.findIndex(y => y.CodigoInsumo === this.agrisService.insumoToAddToCotiz.Nombre) > -1) {
            this.snackBar.open('El insumo que intenta añadir, ya se encuentra en la lista', null, {duration: 3000});
          } else {
            this.insumos.push(this.convertVMtoDetail(this.agrisService.insumoToAddToCotiz, this.agrisService.cantidadInsumo));
          }
          this.agrisService.insumoToAddToCotiz = null;
        }
        // levantamos las ediciones que podrian existir en localstorage
        this.loadInsumoEditedData();
        // buscamos la info de la cuenta para conocer las posibles direcciones de Mail
        this.cuentasService.getCuenta(this.cotizacion.IdCliente.toString()).subscribe(y => {
          const cuenta = y as ClienteViewModel;
          if (cuenta && cuenta.Contacts && cuenta.Contacts.length) {
            cuenta.Contacts = cuenta.Contacts.sort((a, b) => {
              if (a.Principal || b.Principal) {
                return a.Principal ? 1 : -1;
              }
              return 0;
            })
          }
          this.mails = y.Contacts.filter(z => z.Email.trim().length);
        }, err => this.agrisService.showSnackbarAPIError());

        this.updateActividades(x.NumeroCotizacion);

        this.checkViewOficinas();
        this.updateResumenData();
      }
      this.loading = false;
    }, err => {
      this.loading = false;
      this.agrisService.showSnackbarAPIError();
    })
  }

  ngOnDestroy() { this.sub.forEach(x => x.unsubscribe()) }

  openAddInsumoDialog() {
    let dialogRef: MdDialogRef<AgrisInsertInsumCotizDialogComponent>;
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '375px';
    dialogRef = this.dialog.open(AgrisInsertInsumCotizDialogComponent, config);
    dialogRef.componentInstance.oficina = this.cotizacion.IdOficina;
    dialogRef.componentInstance.sucursal = this.cotizacion.IdSucursal;
    this.sub.push(
      dialogRef.afterClosed().subscribe(x => {
        if (x && x.length) {
          const ins = x as InsumoViewModel[];
          let showMaxLengthError = false;
          ins.forEach(y => {
            // no sobreescribimos ni nos pasamos de 30
            if (this.insumos.length === 30) { showMaxLengthError = true; }
            if (this.insumos.length < 30 && this.insumos.findIndex(x => x.CodigoInsumo === y.Nombre) === -1) {
              this.insumos.push(this.convertVMtoDetail(y, y.Multiplo));
            }
          });
          if (showMaxLengthError) {
            this.snackBar.open('Se pueden añadir hasta 30 insumos por cotización', null, {duration: 3000});
          }
          this.saveInsumoEditedData();
          this.updateResumenData();
          this.actualizarCotizacion();
        }
      })
    );
  }

  openEditPriceDialog(insumo: InsumoDetalleCotiz) {
    let dialogRef: MdDialogRef<AgrisEditPriceInsCotizDialogComponent>;
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '343px';
    dialogRef = this.dialog.open(AgrisEditPriceInsCotizDialogComponent, config);
    dialogRef.componentInstance.precio = insumo.PrecioVenta;
    dialogRef.componentInstance.minimo = insumo.PrecioMinimo;
    dialogRef.componentInstance.flete = insumo.Flete;
    dialogRef.componentInstance.margen = insumo.MargenPorcentaje;
    dialogRef.componentInstance.cantidad = insumo.Cantidad;
    dialogRef.componentInstance.nombre = insumo.Nombre;
    this.sub.push(
      dialogRef.afterClosed().subscribe(x => {
        if (x !== null && x !== undefined) {
          insumo.PrecioVenta = Math.max(0, x);
          this.saveInsumoEditedData();
          this.updateResumenData();
          this.actualizarCotizacion();
        }
      })
    );
  }

  openGuardarDialog() {
    if (!this.insumos.length) {
      this.snackBar.open('Debe añadir al menos un insumo para guardar la cotización', null, {duration: 3000});
      return;
    }

    if (this.cantidadSelectors.some(comp => !comp.valid)) {
      this.snackBar.open('Uno o mas precios de insumos contiene errores. Revíselos antes de continuar.', null, {duration: 5000});
      return;
    }

    let dialogRef: MdDialogRef<AgrisCotizDetalleGuardarDialogComponent>;
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '343px';
    dialogRef = this.dialog.open(AgrisCotizDetalleGuardarDialogComponent, config);
    dialogRef.componentInstance.mailAdresses = this.mails;
    dialogRef.componentInstance.selectedMail = this.mails.length ? this.mails[0] : null;
    dialogRef.componentInstance.cliente = this.cotizacion.Cliente;
    // si estamos en una edicion forzada, debemos si o si enviar o descargar, eliminar esta asignacion si se añaden mas casos de edicion forzada
    dialogRef.componentInstance.forceSend = this.forceEdit;
    this.sub.push(
      dialogRef.afterClosed().subscribe(x => {
        if (x !== null && x !== undefined && x !== '') {
          const res = x as GuardarCotizOptions;
          const payload = {...this.cotizacion};
          payload.PDF = res.pdf;
          payload.Mail = res.mail;
          payload.Observacion = res.observacion;
          payload.InsumosCotizacion = this.insumos;
          payload.Contacto = res.contacto;
          this.agrisService.guardarCotizacion(payload).subscribe(y => {
            if (y) {
              // usamos esta variable para evitar problemas de sincronia
              const id = this.cotizacion.NumeroCotizacion;
              this.loadData(id);
              if (res.pdf) {
                this.agrisService.downloadFile(id).subscribe(_ => {}, err => this.agrisService.showSnackbarAPIError());
              }
              this.forceEdit = false;
              this.deleteInsumoEditedData();
            } else {
              this.snackBar.open('No se pudo procesar la información solicitada. Por favor intente nuevamente', null, {duration: 3000});
            }
          }, err => this.agrisService.showSnackbarAPIError());
        }
      })
    );
  }

  openGuardarEnPNJDEDialog() {
    let dialogRef: MdDialogRef<AgrisCotizDetallePnjdeDialogComponent>;
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '343px';
    dialogRef = this.dialog.open(AgrisCotizDetallePnjdeDialogComponent, config);
    this.sub.push(
      dialogRef.afterClosed().subscribe(x => {

      })
    );
  }


  openRenovarDialog() {
    let dialogRef: MdDialogRef<AgrisCotizDetalleRenovarDialogComponent>;
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '343px';
    dialogRef = this.dialog.open(AgrisCotizDetalleRenovarDialogComponent, config);
    this.sub.push(
      dialogRef.afterClosed().subscribe(x => {
        if (x !== null && x !== undefined && (typeof x === 'string') && x.length) {
          this.agrisService.renovarCotizacion({...this.cotizacion, Vigencia: moment(x).unix()}).subscribe(x => {
            if (x && x.NumeroCotizacion) {
              this.loadData(x.NumeroCotizacion);
            } else {
              this.agrisService.showSnackbarAPIError()
            }
          }, err => this.agrisService.showSnackbarAPIError());
        }
      })
    );
  }

  openEditFleteDialog(insumo: InsumoDetalleCotiz) {
    let dialogRef: MdDialogRef<NumberEditDialogComponent>;
    let config = new MdDialogConfig();
    dialogRef = this.dialog.open(NumberEditDialogComponent, config);
    dialogRef.componentInstance.allowZero = false;
    dialogRef.componentInstance.allowNegative = false;
    dialogRef.componentInstance.inputPlaceholder = '';
    dialogRef.componentInstance.title = 'Flete';
    dialogRef.componentInstance.numberToReturn = insumo.Flete;
    this.sub.push(
      dialogRef.afterClosed().subscribe(x => {
        insumo.Flete = x;
      })
    );
  }

  deleteItem(i: number) {
    this.insumos.splice(i, 1);
    this.updateResumenData();
    this.actualizarCotizacion();
  }

  updateResumenData(): void {
    if (!this.cotizacion) {return;}
    this.cotizacion.FacturacionTotal = 0;
    this.cotizacion.MargenTotal = 0;
    this.cotizacion.Porcentaje = 0;
    this.insumos.forEach(x => {
      this.cotizacion.FacturacionTotal = Number(parseFloat((this.cotizacion.FacturacionTotal + (x.PrecioVenta * x.Cantidad)) + "").toFixed(2));
      this.cotizacion.MargenTotal = Number(parseFloat((this.cotizacion.MargenTotal + ((x.PrecioVenta - x.TrmRN2) * x.Cantidad)) + "").toFixed(2));
      x.MargenPorcentaje = Number((((x.PrecioVenta / x.PrecioMinimo) - 1) * 100).toFixed(4));
    });
    this.cotizacion.Porcentaje = this.cotizacion.FacturacionTotal === 0 ? 0 :
    Number(parseFloat((this.cotizacion.MargenTotal / this.cotizacion.FacturacionTotal) + "").toFixed(4));
  }

  editarDatosCotizacion() {
    this.agrisService.editarCotizacion = this.cotizacion;
    this.agrisService.nuevaCotizInsumo = null;
    this.agrisService.forceEdit = this.forceEdit;
    this.router.navigate([PATH_AGRIS_NUEVA_COTIZACION]);
  }

  editable(): boolean {
    if (this.forceEdit) {
      return true;
    }

    if (this.cotizacion !== null && this.cotizacion.EstadosCotizacion && this.cotizacion.EstadosCotizacion.length) {
      return [AgrisEstadosIds.PENDIENTE, AgrisEstadosIds.GUARDADA].indexOf(this.cotizacion.EstadosCotizacion[0].CotizacionAgrisEstadoID) !== -1;
    }
    return false;
  }

  showPerderButton() {
    if (this.cotizacion !== null && this.cotizacion.EstadosCotizacion && this.cotizacion.EstadosCotizacion.length) {
      return [AgrisEstadosIds.PENDIENTE, AgrisEstadosIds.GUARDADA, AgrisEstadosIds.ENVIADA_ACTIVA].indexOf(this.cotizacion.EstadosCotizacion[0].CotizacionAgrisEstadoID) !== -1;
    }
    return false;
  }

  convertVMtoDetail(y: InsumoViewModel, cantidad: number): InsumoDetalleCotiz {
    return {
      Cantidad: cantidad,
      CodigoInsumo: y.Nombre,
      Cot_ID: 0,
      Detalle_ID: 0,
      Flete: 0,
      Margen: 0,
      MargenPorcentaje: y.Margen,
      Nombre: y.Descripcion,
      PrecioLista: y.PrecioPublico,
      PrecioMinimo: y.PrecioMinimo,
      Proveedor: y.DescripcionProveedor,
      Variacion: 0,
      TrmRN2: y.TrmRN2,
      opened: false,
      Multiplo: y.Multiplo,
      UnidadMedida: y.UnidadMedida,
      PrecioVenta: y.PrecioPublico,
      PrecioListaID: y.PrecioListaID,
    }
  }

  descargarPDF() {
    this.agrisService.downloadFile(this.cotizacion.NumeroCotizacion)
      .subscribe(_ => {}, err => this.agrisService.showSnackbarAPIError());
  }

  showDescPDF() {
    // solo se puede descargar PDF para los estados indicados en el array
    return this.cotizacion ?
      [AgrisEstadosIds.GUARDADA, AgrisEstadosIds.ENVIADA_ACTIVA, AgrisEstadosIds.CONFIRMADA]
        .indexOf(this.cotizacion.EstadosCotizacion[0].CotizacionAgrisEstadoID) !== -1
      : false;
  }

  openEditarEnviadaActivaDialog() {
    let dialogRef: MdDialogRef<AgrisConfirmDialogComponent>;
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '343px';
    dialogRef = this.dialog.open(AgrisConfirmDialogComponent, config);
    dialogRef.componentInstance.title = '¿Está seguro que desea editar la cotización?';
    dialogRef.componentInstance.message = 'La cotización ya fue enviada al cliente. Si la modifica, por favor reenviarla.';
    dialogRef.componentInstance.possitive = 'CONTINUAR';
    this.sub.push(
      dialogRef.afterClosed().subscribe(x => {
        if (x) {
          this.forceEdit = true;
        }
      })
    );
  }

  showEditarEnvActiva() {
    return this.cotizacion && !this.forceEdit ?
      this.cotizacion.EstadosCotizacion[0].CotizacionAgrisEstadoID === AgrisEstadosIds.ENVIADA_ACTIVA
      : false;
  }

  openPerderDialog() {
    let dialogRef: MdDialogRef<AgrisCorizPerderDialogComponent>;
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '343px';
    dialogRef = this.dialog.open(AgrisCorizPerderDialogComponent, config);
    this.sub.push(
      dialogRef.afterClosed().subscribe(x => {
        if (x !== null && x !== undefined && x.length) {
          this.agrisService.perderCotizacion({NumeroCotizacion: this.cotizacion.NumeroCotizacion, Observacion: x}).subscribe(y => {
            if (y) {
              this.loadData(this.cotizacion.NumeroCotizacion);
            }
          }, err => this.agrisService.showSnackbarAPIError());
        }
      })
    );
  }

  saveInsumoEditedData() {
    // luego de editar, guardamos la info en caso de no guardarla
    const payload: EditedInsumos = {
      nroCotiz: this.cotizacion.NumeroCotizacion,
      insumos: this.insumos
    };
    localStorage.setItem(editedInsumosKey, JSON.stringify(payload));
  }

  loadInsumoEditedData() {
    const raw = localStorage.getItem(editedInsumosKey);
    if (raw !== null && raw.length) {
      const payload = JSON.parse(raw) as EditedInsumos;
      if (this.cotizacion.NumeroCotizacion === payload.nroCotiz) {
        this.insumos = payload.insumos;
      }
    }
  }

  deleteInsumoEditedData() {
    localStorage.removeItem(editedInsumosKey);
  }

  showGenerarPNButton() {
    return this.cotizacion === null ? false :
      ( this.cotizacion.EstadosCotizacion[0].CotizacionAgrisEstadoID === AgrisEstadosIds.ENVIADA_ACTIVA ||
        this.cotizacion.EstadosCotizacion[0].CotizacionAgrisEstadoID === AgrisEstadosIds.GUARDADA) &&
      this.cotizacion.MetodoFacturacionID !== ModalidadFacturacionIds.DIRECTA &&
      !this.forceEdit;
  }

  generarPN() {
    const id = this.cotizacion.NumeroCotizacion;
    this.spinnerService.setShowFlag(true);
    this.agrisService.generarPNJDE(id).subscribe(x => {
      if (x) {
        this.loadData(id);
      } else {
        this.agrisService.showSnackbarAPIError();
      }
      this.spinnerService.setShowFlag(false);
    }, err => {
      this.agrisService.showSnackbarAPIError();
      this.spinnerService.setShowFlag(false);
    });
  }

  checkViewOficinas() {
    // no es admin de agris, verificamos si por zona puede editar
    if (!this.canView && this.cotizacion !== null) {
      // podremos editar en caso de poder ver la oficina de la cotizacion
      this.canView = this.oficinasVisibles.findIndex(y => y.Id === this.cotizacion.IdOficina) !== -1;
    }
  }

  updateActividades(id: number): void {
    // levantamos las actividades de la cotizacion
    this.actividadLoading = true;
    this.agrisService.getActividadCotizacion(id, 100, 0).subscribe(x => {
      if (x && x.length) {
        this.actividad = x;
      }
      this.actividadLoading = false;
    }, err => {
      this.agrisService.showSnackbarAPIError();
      this.actividadErrMsg = 'Ha ocurrido un error al obtener las actividades'
      this.actividadLoading = false;
    })
  }

  actualizarCotizacion(): void {
    // la cotizacion se actualiza solamente para estado pendiente y guardado, para los demas estados, se debe usar el boton guardar
    if (!this.getIsPendienteOrGuardada) {return;}
    const toUpdate = {...this.cotizacion};
    toUpdate.InsumosCotizacion = this.insumos;
    this.agrisService.editarDatosCotizacion(toUpdate).subscribe(res => {
      if (res) {
        this.snackBar.open(
          'Cotización actualizada correctamente',
          'Cerrar',
          {extraClasses: ['agd-success-snackbar'], duration: 3000}
        );
      }
      this.deleteInsumoEditedData();
    }, err => this.agrisService.showSnackbarAPIError());
  }

  get getIsPendienteOrGuardada(): boolean {
    return [AgrisEstadosIds.PENDIENTE, AgrisEstadosIds.GUARDADA]
      .indexOf(this.cotizacion.EstadosCotizacion[0].CotizacionAgrisEstadoID) !== -1;
  }

  onCantidadChange(insumo, e) {
    insumo.Cantidad = e;
    console.log('debounce Event');
    this.saveInsumoEditedData();
    this.updateResumenData();
    this.actualizarCotizacion();
  }

}

interface EditedInsumos {
  nroCotiz: number;
  insumos: InsumoDetalleCotiz[];
}

interface InsumoDetalleCotiz{
  Detalle_ID: number;
  Cot_ID: number;
  CodigoInsumo: string;
  Nombre: string;
  Proveedor: string;
  PrecioLista: number;
  PrecioMinimo: number;
  Flete: number;
  Cantidad: number;
  Margen: number;
  MargenPorcentaje: number;
  Variacion: number;
  TrmRN2: number;
  opened: boolean;
  UnidadMedida: string;
  Multiplo: number;
  PrecioVenta: number;
  PrecioListaID: number;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-cotizacion-detalle-page.component.ts